export default __webpack_public_path__ + "static/Dosis-Light-c1558d48ef4e79f16c9d97ac0d893aa6.woff";